import KulukorvausForm from './KulukorvausForm';

function App() {
  return <KulukorvausForm />;
}

export default App;